import * as Yup from 'yup';
import i18n from '../../helpers/i18n';

export const validationMultipleSchema = Yup.object({
    deviceType: Yup.string().required(i18n.t('validation.deviceTypeRequired')),
    cnpj: Yup.string().required(i18n.t('validation.cnpjRequired')),
    timezone: Yup.string().required(i18n.t('validation.timezoneRequired')),
    device_for_receipt_flag_multi: Yup.boolean(),
});